import { render, staticRenderFns } from "./SideSubMenu.vue?vue&type=template&id=610f4654&scoped=true"
import script from "./SideSubMenu.vue?vue&type=script&lang=js"
export * from "./SideSubMenu.vue?vue&type=script&lang=js"
import style0 from "./SideSubMenu.vue?vue&type=style&index=0&id=610f4654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610f4654",
  null
  
)

export default component.exports